import { useEffect, useRef } from 'react';

/**
 * `⚠ ` title prefix while `alert` is true — spec 01 §3.5: "`⚠ ` title prefix
 * while hub unreachable / any fleet or account critical." Mounted once in
 * `Layout.tsx`, driven by `useFleetBannerState().tone === 'red'`
 * (`FleetStatusBanner.tsx`): that single computed tone already covers hub
 * unreachable, `gateway_link_lost`, `restart_breaker`, the derived
 * 全部账号离线, AND the account-scope criticals summary — every "red" reason
 * in the priority table — so this hook needs no attention logic of its own.
 *
 * Captures `document.title` on first mount as the "real" title to restore
 * (and when it un-alerts), so it round-trips correctly regardless of what
 * the page's `<title>` happens to be. Restores the real title on unmount too
 * — defensive, since `Layout` is normally the top-level shell and unmounts
 * only on sign-out / navigation away from the console.
 */
export function useDocumentTitleAlert(alert: boolean): void {
  const baseTitleRef = useRef<string | null>(null);

  useEffect(() => {
    if (baseTitleRef.current === null) {
      baseTitleRef.current = document.title;
    }
    return () => {
      if (baseTitleRef.current !== null) {
        document.title = baseTitleRef.current;
      }
    };
  }, []);

  useEffect(() => {
    const base = baseTitleRef.current ?? document.title;
    document.title = alert ? `⚠ ${base}` : base;
  }, [alert]);
}
